import { toast } from '@approvalmax/ui/src/components';
import { errorHelpers } from '@approvalmax/utils';
import { useSetAtom } from 'jotai';
import { domain } from 'modules/data';
import { useCallback, useEffect } from 'react';
import { amplitudeService } from 'services/amplitude';
import { SyncXeroBudgets, useSyncXeroBudgets } from 'shared/data/webApp/v1';

import { messages } from '../messages';
import { syncAllBudgetsPageState } from '../states';

export const useSyncXeroBudgetsMutation = () => {
    const { mutate, isLoading, isSuccess } = useSyncXeroBudgets();
    const setSyncAllBudgetsState = useSetAtom(syncAllBudgetsPageState);

    const syncXeroBudgets = useCallback(
        (data: SyncXeroBudgets['body'], integrationType?: domain.IntegrationType) => {
            if (!integrationType) {
                throw errorHelpers.notImplementedError();
            }

            mutate(
                { body: data },
                {
                    onSuccess: () => {
                        toast.success(messages.syncSuccessful);
                        amplitudeService.sendData(`budgets: pull budgets from ${integrationType}`);
                    },
                }
            );
        },
        [mutate]
    );

    useEffect(() => {
        setSyncAllBudgetsState(isLoading);
    }, [isLoading, setSyncAllBudgetsState]);

    return {
        syncXeroBudgets: syncXeroBudgets,
        isLoadingSyncXeroBudgets: isLoading,
        isSuccessSyncXeroBudgets: isSuccess,
    };
};
